import { i18n } from '@lingui/core';

export const locales = {
  en: 'English',
  es: 'Spanish',
  fr: 'French',
};

export async function activateLocale(locale: keyof typeof locales) {
  const { messages } = await import(`../locales/${locale}/messages.ts`);

  i18n.load(locale, messages);
  i18n.activate(locale);
}
